import type { ComponentDocMap } from './types'

/**
 * Prop documentation for the `base_config` component.
 * Keep in sync with BaseConfigProps in src/ui/uiConfig/components/BaseConfig/BaseConfig.types.ts
 */
export const baseConfigPropDocs: ComponentDocMap = {
  'items[].setting_level': {
    description:
      "Digital-twin object level the item's applied settings belong to. If no object with the item's name exists at that level, the item is not shown; without it, the object is chosen by level precedence (unit first).",
    type: "'model' | 'node' | 'unit' | 'exchange' | 'balance' | 'commodity' | 'byproduct'",
    example: '"balance"',
  },
}
